export enum EnumOcorrenciaRetorno {
    InclusaoAceita = 1,
    AlteracaoAceita = 2,
    ExclusaoAceita = 3,
    AutorizacaoAceita = 4,
    BloqueioAceito = 5,
    DesbloqueioAceito = 6,
    InclusaoRejeitada = 11,
    AlteracaoRejeitada = 12,
    ExclusaoRejeitada = 13,
    AutorizacaoRejeitada = 14,
    BloqueioRejeitado = 15,
    DesbloqueioRejeitado = 16,
    ConfirmacaoCompromissoAntecipadoFornecedor = 17,
    CompromissoAntecipadoFornecedor = 18,
    DocTedDevolvido = 19,
    InsuficienciaFundos = 20,
    BoletosRecusadosPorDivergenciaBase = 21,
    NaoTemosMapeado1 = 22,
    Devolucao = 23,
}